export default function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div
      className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-5 sm:mb-6 fade-in-up"
      data-testid={testId}
    >
      <div className="min-w-0">
        <h1 className="font-display text-xl sm:text-2xl lg:text-3xl font-bold tracking-tight text-gray-900 break-words">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs sm:text-sm text-gray-500 mt-1">{subtitle}</p>
        )}
      </div>
      {actions && (
        <div className="flex items-center flex-wrap gap-2 sm:shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
}
